import React from "react";
import OdxRailnavigationItem from "./Odx-RailnavigationItem";
import {IModulePage} from "../../HubFramework/IHub";
import {odxIconSets} from "../constants";
import ProjectIconNavigation from "../CustomOdx/ProjectIconNavigation";
import {HubPathRouting} from "../../HubFramework/pathBuilder";
import {isUserroleSufficient} from "../../Utils/authorization";
import {UserRoles} from "../../Utils";

interface OdxRailNavigationProps extends React.HTMLAttributes<HTMLDivElement> {
    variant: "default" | "bar"
    navigationItems: IModulePage[]
    currentPage: IModulePage
}

const OdxRailNavigation: React.FC<OdxRailNavigationProps> = ({
                                                                 className,
                                                                 currentPage,
                                                                 variant = "default",
                                                                 navigationItems,
                                                                 ...rest
                                                             }) => {
    const [isOpen, setIsOpen] = React.useState<boolean>(true);

    const combinedClassName = `odx-rail-navigation--${variant} odx-rail-navigation ${isOpen ? 'is-open' : ''}`.trim();

    return (<>
            {HubPathRouting.currentProject && <ProjectIconNavigation/>}
            <div className={combinedClassName} {...rest} id="railNavigation">
                <div>
                    <nav className={"odx-rail-navigation__content"}>
                        {navigationItems
                            .filter(item => !item.separator)
                            .filter(item => isUserroleSufficient(item.minimumRole, HubPathRouting.currentProject?.id, HubPathRouting.currentModule?.id))
                            .map((item, index) => (
                                <OdxRailnavigationItem
                                    key={index}
                                    size={"lg"}
                                    title={item.displayName}
                                    item={item}
                                    isSelected={item.displayName === currentPage?.displayName}
                                />
                            ))}
                    </nav>
                </div>
                <odx-icon-button
                    className={"odx-rail-navigation__expand odx-rail-navigation-item odx-rail-navigation-item notranslate"}
                    variant="ghost"
                    size="lg"
                    type="button"
                    icon={`${odxIconSets.core}::chevron-right`}
                    onClick={() => setIsOpen(!isOpen)}
                />
            </div>
        </>
    )
}

export default OdxRailNavigation;
